import * as Sn from "react";
import Gt, { createContext as at, forwardRef as Ut, useContext as ct, useRef as wn, useMemo as De, createElement as xn } from "react";
const xe = {
  black: "#000",
  white: "#fff"
}, ce = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, fe = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, ue = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, le = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, de = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, ye = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, kn = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function ae(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
const $n = "$$material";
function An(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
function vn(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function Tn(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Bn = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(i) {
      var s;
      r.tags.length === 0 ? r.insertionPoint ? s = r.insertionPoint.nextSibling : r.prepend ? s = r.container.firstChild : s = r.before : s = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(i, s), r.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Tn(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var s = vn(i);
      try {
        s.insertRule(r, s.cssRules.length);
      } catch {
      }
    } else
      i.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      return r.parentNode && r.parentNode.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), F = "-ms-", Le = "-moz-", T = "-webkit-", Ht = "comm", ft = "rule", ut = "decl", On = "@import", Nt = "@keyframes", En = "@layer", Pn = Math.abs, ze = String.fromCharCode, Rn = Object.assign;
function jn(e, t) {
  return L(e, 0) ^ 45 ? (((t << 2 ^ L(e, 0)) << 2 ^ L(e, 1)) << 2 ^ L(e, 2)) << 2 ^ L(e, 3) : 0;
}
function Vt(e) {
  return e.trim();
}
function In(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function B(e, t, n) {
  return e.replace(t, n);
}
function rt(e, t) {
  return e.indexOf(t);
}
function L(e, t) {
  return e.charCodeAt(t) | 0;
}
function ke(e, t, n) {
  return e.slice(t, n);
}
function Y(e) {
  return e.length;
}
function lt(e) {
  return e.length;
}
function Ee(e, t) {
  return t.push(e), e;
}
function _n(e, t) {
  return e.map(t).join("");
}
var Ke = 1, pe = 1, Qt = 0, G = 0, D = 0, me = "";
function Ge(e, t, n, r, i, s, a) {
  return { value: e, root: t, parent: n, type: r, props: i, children: s, line: Ke, column: pe, length: a, return: "" };
}
function be(e, t) {
  return Rn(Ge("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Mn() {
  return D;
}
function Wn() {
  return D = G > 0 ? L(me, --G) : 0, pe--, D === 10 && (pe = 1, Ke--), D;
}
function H() {
  return D = G < Qt ? L(me, G++) : 0, pe++, D === 10 && (pe = 1, Ke++), D;
}
function J() {
  return L(me, G);
}
function Ie() {
  return G;
}
function ve(e, t) {
  return ke(me, e, t);
}
function $e(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function qt(e) {
  return Ke = pe = 1, Qt = Y(me = e), G = 0, [];
}
function Yt(e) {
  return me = "", e;
}
function _e(e) {
  return Vt(ve(G - 1, it(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Dn(e) {
  for (; (D = J()) && D < 33; )
    H();
  return $e(e) > 2 || $e(D) > 3 ? "" : " ";
}
function Ln(e, t) {
  for (; --t && H() && !(D < 48 || D > 102 || D > 57 && D < 65 || D > 70 && D < 97); )
    ;
  return ve(e, Ie() + (t < 6 && J() == 32 && H() == 32));
}
function it(e) {
  for (; H(); )
    switch (D) {
      case e:
        return G;
      case 34:
      case 39:
        e !== 34 && e !== 39 && it(D);
        break;
      case 40:
        e === 41 && it(e);
        break;
      case 92:
        H();
        break;
    }
  return G;
}
function Fn(e, t) {
  for (; H() && e + D !== 57; )
    if (e + D === 84 && J() === 47)
      break;
  return "/*" + ve(t, G - 1) + "*" + ze(e === 47 ? e : H());
}
function zn(e) {
  for (; !$e(J()); )
    H();
  return ve(e, G);
}
function Kn(e) {
  return Yt(Me("", null, null, null, [""], e = qt(e), 0, [0], e));
}
function Me(e, t, n, r, i, s, a, c, f) {
  for (var l = 0, p = 0, d = a, h = 0, m = 0, g = 0, y = 1, A = 1, S = 1, k = 0, w = "", C = i, x = s, P = r, $ = w; A; )
    switch (g = k, k = H()) {
      case 40:
        if (g != 108 && L($, d - 1) == 58) {
          rt($ += B(_e(k), "&", "&\f"), "&\f") != -1 && (S = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        $ += _e(k);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        $ += Dn(g);
        break;
      case 92:
        $ += Ln(Ie() - 1, 7);
        continue;
      case 47:
        switch (J()) {
          case 42:
          case 47:
            Ee(Gn(Fn(H(), Ie()), t, n), f);
            break;
          default:
            $ += "/";
        }
        break;
      case 123 * y:
        c[l++] = Y($) * S;
      case 125 * y:
      case 59:
      case 0:
        switch (k) {
          case 0:
          case 125:
            A = 0;
          case 59 + p:
            S == -1 && ($ = B($, /\f/g, "")), m > 0 && Y($) - d && Ee(m > 32 ? At($ + ";", r, n, d - 1) : At(B($, " ", "") + ";", r, n, d - 2), f);
            break;
          case 59:
            $ += ";";
          default:
            if (Ee(P = $t($, t, n, l, p, i, c, w, C = [], x = [], d), s), k === 123)
              if (p === 0)
                Me($, t, P, P, C, s, d, c, x);
              else
                switch (h === 99 && L($, 3) === 110 ? 100 : h) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Me(e, P, P, r && Ee($t(e, P, P, 0, 0, i, c, w, i, C = [], d), x), i, x, d, c, r ? C : x);
                    break;
                  default:
                    Me($, P, P, P, [""], x, 0, c, x);
                }
        }
        l = p = m = 0, y = S = 1, w = $ = "", d = a;
        break;
      case 58:
        d = 1 + Y($), m = g;
      default:
        if (y < 1) {
          if (k == 123)
            --y;
          else if (k == 125 && y++ == 0 && Wn() == 125)
            continue;
        }
        switch ($ += ze(k), k * y) {
          case 38:
            S = p > 0 ? 1 : ($ += "\f", -1);
            break;
          case 44:
            c[l++] = (Y($) - 1) * S, S = 1;
            break;
          case 64:
            J() === 45 && ($ += _e(H())), h = J(), p = d = Y(w = $ += zn(Ie())), k++;
            break;
          case 45:
            g === 45 && Y($) == 2 && (y = 0);
        }
    }
  return s;
}
function $t(e, t, n, r, i, s, a, c, f, l, p) {
  for (var d = i - 1, h = i === 0 ? s : [""], m = lt(h), g = 0, y = 0, A = 0; g < r; ++g)
    for (var S = 0, k = ke(e, d + 1, d = Pn(y = a[g])), w = e; S < m; ++S)
      (w = Vt(y > 0 ? h[S] + " " + k : B(k, /&\f/g, h[S]))) && (f[A++] = w);
  return Ge(e, t, n, i === 0 ? ft : c, f, l, p);
}
function Gn(e, t, n) {
  return Ge(e, t, n, Ht, ze(Mn()), ke(e, 2, -2), 0);
}
function At(e, t, n, r) {
  return Ge(e, t, n, ut, ke(e, 0, r), ke(e, r + 1, -1), r);
}
function he(e, t) {
  for (var n = "", r = lt(e), i = 0; i < r; i++)
    n += t(e[i], i, e, t) || "";
  return n;
}
function Un(e, t, n, r) {
  switch (e.type) {
    case En:
      if (e.children.length) break;
    case On:
    case ut:
      return e.return = e.return || e.value;
    case Ht:
      return "";
    case Nt:
      return e.return = e.value + "{" + he(e.children, r) + "}";
    case ft:
      e.value = e.props.join(",");
  }
  return Y(n = he(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function Hn(e) {
  var t = lt(e);
  return function(n, r, i, s) {
    for (var a = "", c = 0; c < t; c++)
      a += e[c](n, r, i, s) || "";
    return a;
  };
}
function Nn(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var Vn = function(t, n, r) {
  for (var i = 0, s = 0; i = s, s = J(), i === 38 && s === 12 && (n[r] = 1), !$e(s); )
    H();
  return ve(t, G);
}, Qn = function(t, n) {
  var r = -1, i = 44;
  do
    switch ($e(i)) {
      case 0:
        i === 38 && J() === 12 && (n[r] = 1), t[r] += Vn(G - 1, n, r);
        break;
      case 2:
        t[r] += _e(i);
        break;
      case 4:
        if (i === 44) {
          t[++r] = J() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += ze(i);
    }
  while (i = H());
  return t;
}, qn = function(t, n) {
  return Yt(Qn(qt(t), n));
}, vt = /* @__PURE__ */ new WeakMap(), Yn = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, i = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !vt.get(r)) && !i) {
      vt.set(t, !0);
      for (var s = [], a = qn(n, s), c = r.props, f = 0, l = 0; f < a.length; f++)
        for (var p = 0; p < c.length; p++, l++)
          t.props[l] = s[f] ? a[f].replace(/&\f/g, c[p]) : c[p] + " " + a[f];
    }
  }
}, Xn = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function Xt(e, t) {
  switch (jn(e, t)) {
    case 5103:
      return T + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return T + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return T + e + Le + e + F + e + e;
    case 6828:
    case 4268:
      return T + e + F + e + e;
    case 6165:
      return T + e + F + "flex-" + e + e;
    case 5187:
      return T + e + B(e, /(\w+).+(:[^]+)/, T + "box-$1$2" + F + "flex-$1$2") + e;
    case 5443:
      return T + e + F + "flex-item-" + B(e, /flex-|-self/, "") + e;
    case 4675:
      return T + e + F + "flex-line-pack" + B(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return T + e + F + B(e, "shrink", "negative") + e;
    case 5292:
      return T + e + F + B(e, "basis", "preferred-size") + e;
    case 6060:
      return T + "box-" + B(e, "-grow", "") + T + e + F + B(e, "grow", "positive") + e;
    case 4554:
      return T + B(e, /([^-])(transform)/g, "$1" + T + "$2") + e;
    case 6187:
      return B(B(B(e, /(zoom-|grab)/, T + "$1"), /(image-set)/, T + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return B(e, /(image-set\([^]*)/, T + "$1$`$1");
    case 4968:
      return B(B(e, /(.+:)(flex-)?(.*)/, T + "box-pack:$3" + F + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + T + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return B(e, /(.+)-inline(.+)/, T + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Y(e) - 1 - t > 6) switch (L(e, t + 1)) {
        case 109:
          if (L(e, t + 4) !== 45) break;
        case 102:
          return B(e, /(.+:)(.+)-([^]+)/, "$1" + T + "$2-$3$1" + Le + (L(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~rt(e, "stretch") ? Xt(B(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (L(e, t + 1) !== 115) break;
    case 6444:
      switch (L(e, Y(e) - 3 - (~rt(e, "!important") && 10))) {
        case 107:
          return B(e, ":", ":" + T) + e;
        case 101:
          return B(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + T + (L(e, 14) === 45 ? "inline-" : "") + "box$3$1" + T + "$2$3$1" + F + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (L(e, t + 11)) {
        case 114:
          return T + e + F + B(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return T + e + F + B(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return T + e + F + B(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return T + e + F + e + e;
  }
  return e;
}
var Jn = function(t, n, r, i) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case ut:
      t.return = Xt(t.value, t.length);
      break;
    case Nt:
      return he([be(t, {
        value: B(t.value, "@", "@" + T)
      })], i);
    case ft:
      if (t.length) return _n(t.props, function(s) {
        switch (In(s, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return he([be(t, {
              props: [B(s, /:(read-\w+)/, ":" + Le + "$1")]
            })], i);
          case "::placeholder":
            return he([be(t, {
              props: [B(s, /:(plac\w+)/, ":" + T + "input-$1")]
            }), be(t, {
              props: [B(s, /:(plac\w+)/, ":" + Le + "$1")]
            }), be(t, {
              props: [B(s, /:(plac\w+)/, F + "input-$1")]
            })], i);
        }
        return "";
      });
  }
}, Zn = [Jn], er = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(y) {
      var A = y.getAttribute("data-emotion");
      A.indexOf(" ") !== -1 && (document.head.appendChild(y), y.setAttribute("data-s", ""));
    });
  }
  var i = t.stylisPlugins || Zn, s = {}, a, c = [];
  a = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(y) {
      for (var A = y.getAttribute("data-emotion").split(" "), S = 1; S < A.length; S++)
        s[A[S]] = !0;
      c.push(y);
    }
  );
  var f, l = [Yn, Xn];
  {
    var p, d = [Un, Nn(function(y) {
      p.insert(y);
    })], h = Hn(l.concat(i, d)), m = function(A) {
      return he(Kn(A), h);
    };
    f = function(A, S, k, w) {
      p = k, m(A ? A + "{" + S.styles + "}" : S.styles), w && (g.inserted[S.name] = !0);
    };
  }
  var g = {
    key: n,
    sheet: new Bn({
      key: n,
      container: a,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: s,
    registered: {},
    insert: f
  };
  return g.sheet.hydrate(c), g;
}, tr = !0;
function nr(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(i) {
    e[i] !== void 0 ? t.push(e[i] + ";") : r += i + " ";
  }), r;
}
var rr = function(t, n, r) {
  var i = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  tr === !1) && t.registered[i] === void 0 && (t.registered[i] = n.styles);
}, ir = function(t, n, r) {
  rr(t, n, r);
  var i = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var s = n;
    do
      t.insert(n === s ? "." + i : "", s, t.sheet, !0), s = s.next;
    while (s !== void 0);
  }
};
function sr(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var or = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, ar = /[A-Z]|^ms/g, cr = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Jt = function(t) {
  return t.charCodeAt(1) === 45;
}, Tt = function(t) {
  return t != null && typeof t != "boolean";
}, et = /* @__PURE__ */ An(function(e) {
  return Jt(e) ? e : e.replace(ar, "-$&").toLowerCase();
}), Bt = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(cr, function(r, i, s) {
          return X = {
            name: i,
            styles: s,
            next: X
          }, i;
        });
  }
  return or[t] !== 1 && !Jt(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function Ae(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return X = {
          name: n.name,
          styles: n.styles,
          next: X
        }, n.name;
      if (n.styles !== void 0) {
        var r = n.next;
        if (r !== void 0)
          for (; r !== void 0; )
            X = {
              name: r.name,
              styles: r.styles,
              next: X
            }, r = r.next;
        var i = n.styles + ";";
        return i;
      }
      return fr(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var s = X, a = n(e);
        return X = s, Ae(e, t, a);
      }
      break;
    }
  }
  if (t == null)
    return n;
  var c = t[n];
  return c !== void 0 ? c : n;
}
function fr(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += Ae(e, t, n[i]) + ";";
  else
    for (var s in n) {
      var a = n[s];
      if (typeof a != "object")
        t != null && t[a] !== void 0 ? r += s + "{" + t[a] + "}" : Tt(a) && (r += et(s) + ":" + Bt(s, a) + ";");
      else if (Array.isArray(a) && typeof a[0] == "string" && (t == null || t[a[0]] === void 0))
        for (var c = 0; c < a.length; c++)
          Tt(a[c]) && (r += et(s) + ":" + Bt(s, a[c]) + ";");
      else {
        var f = Ae(e, t, a);
        switch (s) {
          case "animation":
          case "animationName": {
            r += et(s) + ":" + f + ";";
            break;
          }
          default:
            r += s + "{" + f + "}";
        }
      }
    }
  return r;
}
var Ot = /label:\s*([^\s;\n{]+)\s*(;|$)/g, X, ur = function(t, n, r) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var i = !0, s = "";
  X = void 0;
  var a = t[0];
  a == null || a.raw === void 0 ? (i = !1, s += Ae(r, n, a)) : s += a[0];
  for (var c = 1; c < t.length; c++)
    s += Ae(r, n, t[c]), i && (s += a[c]);
  Ot.lastIndex = 0;
  for (var f = "", l; (l = Ot.exec(s)) !== null; )
    f += "-" + // $FlowFixMe we know it's not null
    l[1];
  var p = sr(s) + f;
  return {
    name: p,
    styles: s,
    next: X
  };
}, dt = /* @__PURE__ */ at(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ er({
    key: "css"
  }) : null
), ms = dt.Provider, lr = function() {
  return ct(dt);
}, ys = function(t) {
  return /* @__PURE__ */ Ut(function(n, r) {
    var i = ct(dt);
    return t(n, i, r);
  });
}, dr = /* @__PURE__ */ at({});
function ne(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Zt(e) {
  if (!ne(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = Zt(e[n]);
  }), t;
}
function K(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? {
    ...e
  } : e;
  return ne(e) && ne(t) && Object.keys(t).forEach((i) => {
    ne(t[i]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, i) && ne(e[i]) ? r[i] = K(e[i], t[i], n) : n.clone ? r[i] = ne(t[i]) ? Zt(t[i]) : t[i] : r[i] = t[i];
  }), r;
}
const hr = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => ({
    ...n,
    [r.key]: r.val
  }), {});
};
function gr(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5,
    ...i
  } = e, s = hr(t), a = Object.keys(s);
  function c(h) {
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${n})`;
  }
  function f(h) {
    return `@media (max-width:${(typeof t[h] == "number" ? t[h] : h) - r / 100}${n})`;
  }
  function l(h, m) {
    const g = a.indexOf(m);
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${n}) and (max-width:${(g !== -1 && typeof t[a[g]] == "number" ? t[a[g]] : m) - r / 100}${n})`;
  }
  function p(h) {
    return a.indexOf(h) + 1 < a.length ? l(h, a[a.indexOf(h) + 1]) : c(h);
  }
  function d(h) {
    const m = a.indexOf(h);
    return m === 0 ? c(a[1]) : m === a.length - 1 ? f(a[m]) : l(h, a[a.indexOf(h) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: a,
    values: s,
    up: c,
    down: f,
    between: l,
    only: p,
    not: d,
    unit: n,
    ...i
  };
}
function pr(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((r) => r.startsWith("@container")).sort((r, i) => {
    var a, c;
    const s = /min-width:\s*([0-9.]+)/;
    return +(((a = r.match(s)) == null ? void 0 : a[1]) || 0) - +(((c = i.match(s)) == null ? void 0 : c[1]) || 0);
  });
  return n.length ? n.reduce((r, i) => {
    const s = t[i];
    return delete r[i], r[i] = s, r;
  }, {
    ...t
  }) : t;
}
function mr(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function yr(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n)
    return null;
  const [, r, i] = n, s = Number.isNaN(+r) ? r || 0 : +r;
  return e.containerQueries(i).up(s);
}
function br(e) {
  const t = (s, a) => s.replace("@media", a ? `@container ${a}` : "@container");
  function n(s, a) {
    s.up = (...c) => t(e.breakpoints.up(...c), a), s.down = (...c) => t(e.breakpoints.down(...c), a), s.between = (...c) => t(e.breakpoints.between(...c), a), s.only = (...c) => t(e.breakpoints.only(...c), a), s.not = (...c) => {
      const f = t(e.breakpoints.not(...c), a);
      return f.includes("not all and") ? f.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : f;
    };
  }
  const r = {}, i = (s) => (n(r, s), r);
  return n(i), {
    ...e,
    containerQueries: i
  };
}
const Cr = {
  borderRadius: 4
};
function we(e, t) {
  return t ? K(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Ue = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, Et = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Ue[e]}px)`
}, Sr = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : Ue[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function ee(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const s = r.breakpoints || Et;
    return t.reduce((a, c, f) => (a[s.up(s.keys[f])] = n(t[f]), a), {});
  }
  if (typeof t == "object") {
    const s = r.breakpoints || Et;
    return Object.keys(t).reduce((a, c) => {
      if (mr(s.keys, c)) {
        const f = yr(r.containerQueries ? r : Sr, c);
        f && (a[f] = n(t[c], c));
      } else if (Object.keys(s.values || Ue).includes(c)) {
        const f = s.up(c);
        a[f] = n(t[c], c);
      } else {
        const f = c;
        a[f] = t[f];
      }
      return a;
    }, {});
  }
  return n(t);
}
function en(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((r, i) => {
    const s = e.up(i);
    return r[s] = {}, r;
  }, {})) || {};
}
function tn(e, t) {
  return e.reduce((n, r) => {
    const i = n[r];
    return (!i || Object.keys(i).length === 0) && delete n[r], n;
  }, t);
}
function bs(e, ...t) {
  const n = en(e), r = [n, ...t].reduce((i, s) => K(i, s), {});
  return tn(Object.keys(n), r);
}
function wr(e, t) {
  if (typeof e != "object")
    return {};
  const n = {}, r = Object.keys(t);
  return Array.isArray(e) ? r.forEach((i, s) => {
    s < e.length && (n[i] = !0);
  }) : r.forEach((i) => {
    e[i] != null && (n[i] = !0);
  }), n;
}
function Cs({
  values: e,
  breakpoints: t,
  base: n
}) {
  const r = n || wr(e, t), i = Object.keys(r);
  if (i.length === 0)
    return e;
  let s;
  return i.reduce((a, c, f) => (Array.isArray(e) ? (a[c] = e[f] != null ? e[f] : e[s], s = f) : typeof e == "object" ? (a[c] = e[c] != null ? e[c] : e[s], s = c) : a[c] = e, a), {});
}
function nn(e) {
  if (typeof e != "string")
    throw new Error(ae(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function He(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((i, s) => i && i[s] ? i[s] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, i) => r && r[i] != null ? r[i] : null, e);
}
function Fe(e, t, n, r = n) {
  let i;
  return typeof e == "function" ? i = e(n) : Array.isArray(e) ? i = e[n] || r : i = He(e, n) || r, t && (i = t(i, r, e)), i;
}
function W(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: i
  } = e, s = (a) => {
    if (a[t] == null)
      return null;
    const c = a[t], f = a.theme, l = He(f, r) || {};
    return ee(a, c, (d) => {
      let h = Fe(l, i, d);
      return d === h && typeof d == "string" && (h = Fe(l, i, `${t}${d === "default" ? "" : nn(d)}`, d)), n === !1 ? h : {
        [n]: h
      };
    });
  };
  return s.propTypes = {}, s.filterProps = [t], s;
}
function xr(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const kr = {
  m: "margin",
  p: "padding"
}, $r = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, Pt = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, Ar = xr((e) => {
  if (e.length > 2)
    if (Pt[e])
      e = Pt[e];
    else
      return [e];
  const [t, n] = e.split(""), r = kr[t], i = $r[n] || "";
  return Array.isArray(i) ? i.map((s) => r + s) : [r + i];
}), ht = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], gt = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
[...ht, ...gt];
function Te(e, t, n, r) {
  const i = He(e, t, !0) ?? n;
  return typeof i == "number" || typeof i == "string" ? (s) => typeof s == "string" ? s : typeof i == "string" ? `calc(${s} * ${i})` : i * s : Array.isArray(i) ? (s) => {
    if (typeof s == "string")
      return s;
    const a = Math.abs(s), c = i[a];
    return s >= 0 ? c : typeof c == "number" ? -c : `-${c}`;
  } : typeof i == "function" ? i : () => {
  };
}
function pt(e) {
  return Te(e, "spacing", 8);
}
function Be(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function vr(e, t) {
  return (n) => e.reduce((r, i) => (r[i] = Be(t, n), r), {});
}
function Tr(e, t, n, r) {
  if (!t.includes(n))
    return null;
  const i = Ar(n), s = vr(i, r), a = e[n];
  return ee(e, a, s);
}
function rn(e, t) {
  const n = pt(e.theme);
  return Object.keys(e).map((r) => Tr(e, t, r, n)).reduce(we, {});
}
function _(e) {
  return rn(e, ht);
}
_.propTypes = {};
_.filterProps = ht;
function M(e) {
  return rn(e, gt);
}
M.propTypes = {};
M.filterProps = gt;
function sn(e = 8, t = pt({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...r) => (r.length === 0 ? [1] : r).map((s) => {
    const a = t(s);
    return typeof a == "number" ? `${a}px` : a;
  }).join(" ");
  return n.mui = !0, n;
}
function Ne(...e) {
  const t = e.reduce((r, i) => (i.filterProps.forEach((s) => {
    r[s] = i;
  }), r), {}), n = (r) => Object.keys(r).reduce((i, s) => t[s] ? we(i, t[s](r)) : i, {});
  return n.propTypes = {}, n.filterProps = e.reduce((r, i) => r.concat(i.filterProps), []), n;
}
function N(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function V(e, t) {
  return W({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const Br = V("border", N), Or = V("borderTop", N), Er = V("borderRight", N), Pr = V("borderBottom", N), Rr = V("borderLeft", N), jr = V("borderColor"), Ir = V("borderTopColor"), _r = V("borderRightColor"), Mr = V("borderBottomColor"), Wr = V("borderLeftColor"), Dr = V("outline", N), Lr = V("outlineColor"), Ve = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = Te(e.theme, "shape.borderRadius", 4), n = (r) => ({
      borderRadius: Be(t, r)
    });
    return ee(e, e.borderRadius, n);
  }
  return null;
};
Ve.propTypes = {};
Ve.filterProps = ["borderRadius"];
Ne(Br, Or, Er, Pr, Rr, jr, Ir, _r, Mr, Wr, Ve, Dr, Lr);
const Qe = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = Te(e.theme, "spacing", 8), n = (r) => ({
      gap: Be(t, r)
    });
    return ee(e, e.gap, n);
  }
  return null;
};
Qe.propTypes = {};
Qe.filterProps = ["gap"];
const qe = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = Te(e.theme, "spacing", 8), n = (r) => ({
      columnGap: Be(t, r)
    });
    return ee(e, e.columnGap, n);
  }
  return null;
};
qe.propTypes = {};
qe.filterProps = ["columnGap"];
const Ye = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = Te(e.theme, "spacing", 8), n = (r) => ({
      rowGap: Be(t, r)
    });
    return ee(e, e.rowGap, n);
  }
  return null;
};
Ye.propTypes = {};
Ye.filterProps = ["rowGap"];
const Fr = W({
  prop: "gridColumn"
}), zr = W({
  prop: "gridRow"
}), Kr = W({
  prop: "gridAutoFlow"
}), Gr = W({
  prop: "gridAutoColumns"
}), Ur = W({
  prop: "gridAutoRows"
}), Hr = W({
  prop: "gridTemplateColumns"
}), Nr = W({
  prop: "gridTemplateRows"
}), Vr = W({
  prop: "gridTemplateAreas"
}), Qr = W({
  prop: "gridArea"
});
Ne(Qe, qe, Ye, Fr, zr, Kr, Gr, Ur, Hr, Nr, Vr, Qr);
function ge(e, t) {
  return t === "grey" ? t : e;
}
const qr = W({
  prop: "color",
  themeKey: "palette",
  transform: ge
}), Yr = W({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: ge
}), Xr = W({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: ge
});
Ne(qr, Yr, Xr);
function U(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const Jr = W({
  prop: "width",
  transform: U
}), mt = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var i, s, a, c, f;
      const r = ((a = (s = (i = e.theme) == null ? void 0 : i.breakpoints) == null ? void 0 : s.values) == null ? void 0 : a[n]) || Ue[n];
      return r ? ((f = (c = e.theme) == null ? void 0 : c.breakpoints) == null ? void 0 : f.unit) !== "px" ? {
        maxWidth: `${r}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: r
      } : {
        maxWidth: U(n)
      };
    };
    return ee(e, e.maxWidth, t);
  }
  return null;
};
mt.filterProps = ["maxWidth"];
const Zr = W({
  prop: "minWidth",
  transform: U
}), ei = W({
  prop: "height",
  transform: U
}), ti = W({
  prop: "maxHeight",
  transform: U
}), ni = W({
  prop: "minHeight",
  transform: U
});
W({
  prop: "size",
  cssProperty: "width",
  transform: U
});
W({
  prop: "size",
  cssProperty: "height",
  transform: U
});
const ri = W({
  prop: "boxSizing"
});
Ne(Jr, mt, Zr, ei, ti, ni, ri);
const Xe = {
  // borders
  border: {
    themeKey: "borders",
    transform: N
  },
  borderTop: {
    themeKey: "borders",
    transform: N
  },
  borderRight: {
    themeKey: "borders",
    transform: N
  },
  borderBottom: {
    themeKey: "borders",
    transform: N
  },
  borderLeft: {
    themeKey: "borders",
    transform: N
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: N
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Ve
  },
  // palette
  color: {
    themeKey: "palette",
    transform: ge
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: ge
  },
  backgroundColor: {
    themeKey: "palette",
    transform: ge
  },
  // spacing
  p: {
    style: M
  },
  pt: {
    style: M
  },
  pr: {
    style: M
  },
  pb: {
    style: M
  },
  pl: {
    style: M
  },
  px: {
    style: M
  },
  py: {
    style: M
  },
  padding: {
    style: M
  },
  paddingTop: {
    style: M
  },
  paddingRight: {
    style: M
  },
  paddingBottom: {
    style: M
  },
  paddingLeft: {
    style: M
  },
  paddingX: {
    style: M
  },
  paddingY: {
    style: M
  },
  paddingInline: {
    style: M
  },
  paddingInlineStart: {
    style: M
  },
  paddingInlineEnd: {
    style: M
  },
  paddingBlock: {
    style: M
  },
  paddingBlockStart: {
    style: M
  },
  paddingBlockEnd: {
    style: M
  },
  m: {
    style: _
  },
  mt: {
    style: _
  },
  mr: {
    style: _
  },
  mb: {
    style: _
  },
  ml: {
    style: _
  },
  mx: {
    style: _
  },
  my: {
    style: _
  },
  margin: {
    style: _
  },
  marginTop: {
    style: _
  },
  marginRight: {
    style: _
  },
  marginBottom: {
    style: _
  },
  marginLeft: {
    style: _
  },
  marginX: {
    style: _
  },
  marginY: {
    style: _
  },
  marginInline: {
    style: _
  },
  marginInlineStart: {
    style: _
  },
  marginInlineEnd: {
    style: _
  },
  marginBlock: {
    style: _
  },
  marginBlockStart: {
    style: _
  },
  marginBlockEnd: {
    style: _
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Qe
  },
  rowGap: {
    style: Ye
  },
  columnGap: {
    style: qe
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: U
  },
  maxWidth: {
    style: mt
  },
  minWidth: {
    transform: U
  },
  height: {
    transform: U
  },
  maxHeight: {
    transform: U
  },
  minHeight: {
    transform: U
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function ii(...e) {
  const t = e.reduce((r, i) => r.concat(Object.keys(i)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function si(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function oi() {
  function e(n, r, i, s) {
    const a = {
      [n]: r,
      theme: i
    }, c = s[n];
    if (!c)
      return {
        [n]: r
      };
    const {
      cssProperty: f = n,
      themeKey: l,
      transform: p,
      style: d
    } = c;
    if (r == null)
      return null;
    if (l === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const h = He(i, l) || {};
    return d ? d(a) : ee(a, r, (g) => {
      let y = Fe(h, p, g);
      return g === y && typeof g == "string" && (y = Fe(h, p, `${n}${g === "default" ? "" : nn(g)}`, g)), f === !1 ? y : {
        [f]: y
      };
    });
  }
  function t(n) {
    const {
      sx: r,
      theme: i = {}
    } = n || {};
    if (!r)
      return null;
    const s = i.unstable_sxConfig ?? Xe;
    function a(c) {
      let f = c;
      if (typeof c == "function")
        f = c(i);
      else if (typeof c != "object")
        return c;
      if (!f)
        return null;
      const l = en(i.breakpoints), p = Object.keys(l);
      let d = l;
      return Object.keys(f).forEach((h) => {
        const m = si(f[h], i);
        if (m != null)
          if (typeof m == "object")
            if (s[h])
              d = we(d, e(h, m, i, s));
            else {
              const g = ee({
                theme: i
              }, m, (y) => ({
                [h]: y
              }));
              ii(g, m) ? d[h] = t({
                sx: m,
                theme: i
              }) : d = we(d, g);
            }
          else
            d = we(d, e(h, m, i, s));
      }), pr(i, tn(p, d));
    }
    return Array.isArray(r) ? r.map(a) : a(r);
  }
  return t;
}
const Je = oi();
Je.filterProps = ["sx"];
function ai(e, t) {
  var r;
  const n = this;
  if (n.vars) {
    if (!((r = n.colorSchemes) != null && r[e]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let i = n.getColorSchemeSelector(e);
    return i === "&" ? t : ((i.includes("data-") || i.includes(".")) && (i = `*:where(${i.replace(/\s*&$/, "")}) &`), {
      [i]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function on(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: i,
    shape: s = {},
    ...a
  } = e, c = gr(n), f = sn(i);
  let l = K({
    breakpoints: c,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...r
    },
    spacing: f,
    shape: {
      ...Cr,
      ...s
    }
  }, a);
  return l = br(l), l.applyStyles = ai, l = t.reduce((p, d) => K(p, d), l), l.unstable_sxConfig = {
    ...Xe,
    ...a == null ? void 0 : a.unstable_sxConfig
  }, l.unstable_sx = function(d) {
    return Je({
      sx: d,
      theme: this
    });
  }, l;
}
function ci(e) {
  return Object.keys(e).length === 0;
}
function fi(e = null) {
  const t = Sn.useContext(dr);
  return !t || ci(t) ? e : t;
}
const ui = on();
function li(e = ui) {
  return fi(e);
}
function di(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function yt(e, t = 0, n = 1) {
  return di(e, t, n);
}
function hi(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, i) => i < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function re(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return re(hi(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(ae(9, e));
  let r = e.substring(t + 1, e.length - 1), i;
  if (n === "color") {
    if (r = r.split(" "), i = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(i))
      throw new Error(ae(10, i));
  } else
    r = r.split(",");
  return r = r.map((s) => parseFloat(s)), {
    type: n,
    values: r,
    colorSpace: i
  };
}
const gi = (e) => {
  const t = re(e);
  return t.values.slice(0, 3).map((n, r) => t.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, Ce = (e, t) => {
  try {
    return gi(e);
  } catch {
    return e;
  }
};
function Ze(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.includes("rgb") ? r = r.map((i, s) => s < 3 ? parseInt(i, 10) : i) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function an(e) {
  e = re(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, i = t[2] / 100, s = r * Math.min(i, 1 - i), a = (l, p = (l + n / 30) % 12) => i - s * Math.max(Math.min(p - 3, 9 - p, 1), -1);
  let c = "rgb";
  const f = [Math.round(a(0) * 255), Math.round(a(8) * 255), Math.round(a(4) * 255)];
  return e.type === "hsla" && (c += "a", f.push(t[3])), Ze({
    type: c,
    values: f
  });
}
function st(e) {
  e = re(e);
  let t = e.type === "hsl" || e.type === "hsla" ? re(an(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function pi(e, t) {
  const n = st(e), r = st(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function mi(e, t) {
  return e = re(e), t = yt(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, Ze(e);
}
function Pe(e, t, n) {
  try {
    return mi(e, t);
  } catch {
    return e;
  }
}
function bt(e, t) {
  if (e = re(e), t = yt(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return Ze(e);
}
function O(e, t, n) {
  try {
    return bt(e, t);
  } catch {
    return e;
  }
}
function Ct(e, t) {
  if (e = re(e), t = yt(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return Ze(e);
}
function E(e, t, n) {
  try {
    return Ct(e, t);
  } catch {
    return e;
  }
}
function yi(e, t = 0.15) {
  return st(e) > 0.5 ? bt(e, t) : Ct(e, t);
}
function Re(e, t, n) {
  try {
    return yi(e, t);
  } catch {
    return e;
  }
}
function bi(e = "") {
  function t(...r) {
    if (!r.length)
      return "";
    const i = r[0];
    return typeof i == "string" && !i.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${i}${t(...r.slice(1))})` : `, ${i}`;
  }
  return (r, ...i) => `var(--${e ? `${e}-` : ""}${r}${t(...i)})`;
}
const Rt = (e, t, n, r = []) => {
  let i = e;
  t.forEach((s, a) => {
    a === t.length - 1 ? Array.isArray(i) ? i[Number(s)] = n : i && typeof i == "object" && (i[s] = n) : i && typeof i == "object" && (i[s] || (i[s] = r.includes(s) ? [] : {}), i = i[s]);
  });
}, Ci = (e, t, n) => {
  function r(i, s = [], a = []) {
    Object.entries(i).forEach(([c, f]) => {
      (!n || n && !n([...s, c])) && f != null && (typeof f == "object" && Object.keys(f).length > 0 ? r(f, [...s, c], Array.isArray(f) ? [...a, c] : a) : t([...s, c], f, a));
    });
  }
  r(e);
}, Si = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((r) => e.includes(r)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function tt(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = t || {}, i = {}, s = {}, a = {};
  return Ci(
    e,
    (c, f, l) => {
      if ((typeof f == "string" || typeof f == "number") && (!r || !r(c, f))) {
        const p = `--${n ? `${n}-` : ""}${c.join("-")}`, d = Si(c, f);
        Object.assign(i, {
          [p]: d
        }), Rt(s, c, `var(${p})`, l), Rt(a, c, `var(${p}, ${d})`, l);
      }
    },
    (c) => c[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: i,
    vars: s,
    varsWithDefaults: a
  };
}
function wi(e, t = {}) {
  const {
    getSelector: n = A,
    disableCssColorScheme: r,
    colorSchemeSelector: i
  } = t, {
    colorSchemes: s = {},
    components: a,
    defaultColorScheme: c = "light",
    ...f
  } = e, {
    vars: l,
    css: p,
    varsWithDefaults: d
  } = tt(f, t);
  let h = d;
  const m = {}, {
    [c]: g,
    ...y
  } = s;
  if (Object.entries(y || {}).forEach(([w, C]) => {
    const {
      vars: x,
      css: P,
      varsWithDefaults: $
    } = tt(C, t);
    h = K(h, $), m[w] = {
      css: P,
      vars: x
    };
  }), g) {
    const {
      css: w,
      vars: C,
      varsWithDefaults: x
    } = tt(g, t);
    h = K(h, x), m[c] = {
      css: w,
      vars: C
    };
  }
  function A(w, C) {
    var P, $;
    let x = i;
    if (i === "class" && (x = ".%s"), i === "data" && (x = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (x = `[${i}="%s"]`), w) {
      if (x === "media")
        return e.defaultColorScheme === w ? ":root" : {
          [`@media (prefers-color-scheme: ${(($ = (P = s[w]) == null ? void 0 : P.palette) == null ? void 0 : $.mode) || w})`]: {
            ":root": C
          }
        };
      if (x)
        return e.defaultColorScheme === w ? `:root, ${x.replace("%s", String(w))}` : x.replace("%s", String(w));
    }
    return ":root";
  }
  return {
    vars: h,
    generateThemeVars: () => {
      let w = {
        ...l
      };
      return Object.entries(m).forEach(([, {
        vars: C
      }]) => {
        w = K(w, C);
      }), w;
    },
    generateStyleSheets: () => {
      var z, R;
      const w = [], C = e.defaultColorScheme || "light";
      function x(o, b) {
        Object.keys(b).length && w.push(typeof o == "string" ? {
          [o]: {
            ...b
          }
        } : o);
      }
      x(n(void 0, {
        ...p
      }), p);
      const {
        [C]: P,
        ...$
      } = m;
      if (P) {
        const {
          css: o
        } = P, b = (R = (z = s[C]) == null ? void 0 : z.palette) == null ? void 0 : R.mode, v = !r && b ? {
          colorScheme: b,
          ...o
        } : {
          ...o
        };
        x(n(C, {
          ...v
        }), v);
      }
      return Object.entries($).forEach(([o, {
        css: b
      }]) => {
        var Q, Oe;
        const v = (Oe = (Q = s[o]) == null ? void 0 : Q.palette) == null ? void 0 : Oe.mode, j = !r && v ? {
          colorScheme: v,
          ...b
        } : {
          ...b
        };
        x(n(o, {
          ...j
        }), j);
      }), w;
    }
  };
}
function xi(e) {
  return function(n) {
    return e === "media" ? `@media (prefers-color-scheme: ${n})` : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
function cn() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: xe.white,
      default: xe.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const ki = cn();
function fn() {
  return {
    text: {
      primary: xe.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: xe.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const jt = fn();
function It(e, t, n, r) {
  const i = r.light || r, s = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = Ct(e.main, i) : t === "dark" && (e.dark = bt(e.main, s)));
}
function $i(e = "light") {
  return e === "dark" ? {
    main: ue[200],
    light: ue[50],
    dark: ue[400]
  } : {
    main: ue[700],
    light: ue[400],
    dark: ue[800]
  };
}
function Ai(e = "light") {
  return e === "dark" ? {
    main: fe[200],
    light: fe[50],
    dark: fe[400]
  } : {
    main: fe[500],
    light: fe[300],
    dark: fe[700]
  };
}
function vi(e = "light") {
  return e === "dark" ? {
    main: ce[500],
    light: ce[300],
    dark: ce[700]
  } : {
    main: ce[700],
    light: ce[400],
    dark: ce[800]
  };
}
function Ti(e = "light") {
  return e === "dark" ? {
    main: le[400],
    light: le[300],
    dark: le[700]
  } : {
    main: le[700],
    light: le[500],
    dark: le[900]
  };
}
function Bi(e = "light") {
  return e === "dark" ? {
    main: de[400],
    light: de[300],
    dark: de[700]
  } : {
    main: de[800],
    light: de[500],
    dark: de[900]
  };
}
function Oi(e = "light") {
  return e === "dark" ? {
    main: ye[400],
    light: ye[300],
    dark: ye[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: ye[500],
    dark: ye[900]
  };
}
function St(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2,
    ...i
  } = e, s = e.primary || $i(t), a = e.secondary || Ai(t), c = e.error || vi(t), f = e.info || Ti(t), l = e.success || Bi(t), p = e.warning || Oi(t);
  function d(y) {
    return pi(y, jt.text.primary) >= n ? jt.text.primary : ki.text.primary;
  }
  const h = ({
    color: y,
    name: A,
    mainShade: S = 500,
    lightShade: k = 300,
    darkShade: w = 700
  }) => {
    if (y = {
      ...y
    }, !y.main && y[S] && (y.main = y[S]), !y.hasOwnProperty("main"))
      throw new Error(ae(11, A ? ` (${A})` : "", S));
    if (typeof y.main != "string")
      throw new Error(ae(12, A ? ` (${A})` : "", JSON.stringify(y.main)));
    return It(y, "light", k, r), It(y, "dark", w, r), y.contrastText || (y.contrastText = d(y.main)), y;
  };
  let m;
  return t === "light" ? m = cn() : t === "dark" && (m = fn()), K({
    // A collection of common colors.
    common: {
      ...xe
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: h({
      color: s,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: h({
      color: a,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: h({
      color: c,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: h({
      color: p,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: h({
      color: f,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: h({
      color: l,
      name: "success"
    }),
    // The grey colors.
    grey: kn,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: d,
    // Generate a rich color object.
    augmentColor: h,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r,
    // The light and dark mode object.
    ...m
  }, i);
}
function Ei(e) {
  const t = {};
  return Object.entries(e).forEach((r) => {
    const [i, s] = r;
    typeof s == "object" && (t[i] = `${s.fontStyle ? `${s.fontStyle} ` : ""}${s.fontVariant ? `${s.fontVariant} ` : ""}${s.fontWeight ? `${s.fontWeight} ` : ""}${s.fontStretch ? `${s.fontStretch} ` : ""}${s.fontSize || ""}${s.lineHeight ? `/${s.lineHeight} ` : ""}${s.fontFamily || ""}`);
  }), t;
}
function Pi(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function Ri(e) {
  return Math.round(e * 1e5) / 1e5;
}
const _t = {
  textTransform: "uppercase"
}, Mt = '"Roboto", "Helvetica", "Arial", sans-serif';
function ji(e, t) {
  const {
    fontFamily: n = Mt,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: s = 400,
    fontWeightMedium: a = 500,
    fontWeightBold: c = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: f = 16,
    // Apply the CSS properties to all the variants.
    allVariants: l,
    pxToRem: p,
    ...d
  } = typeof t == "function" ? t(e) : t, h = r / 14, m = p || ((A) => `${A / f * h}rem`), g = (A, S, k, w, C) => ({
    fontFamily: n,
    fontWeight: A,
    fontSize: m(S),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: k,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === Mt ? {
      letterSpacing: `${Ri(w / S)}em`
    } : {},
    ...C,
    ...l
  }), y = {
    h1: g(i, 96, 1.167, -1.5),
    h2: g(i, 60, 1.2, -0.5),
    h3: g(s, 48, 1.167, 0),
    h4: g(s, 34, 1.235, 0.25),
    h5: g(s, 24, 1.334, 0),
    h6: g(a, 20, 1.6, 0.15),
    subtitle1: g(s, 16, 1.75, 0.15),
    subtitle2: g(a, 14, 1.57, 0.1),
    body1: g(s, 16, 1.5, 0.15),
    body2: g(s, 14, 1.43, 0.15),
    button: g(a, 14, 1.75, 0.4, _t),
    caption: g(s, 12, 1.66, 0.4),
    overline: g(s, 12, 2.66, 1, _t),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return K({
    htmlFontSize: f,
    pxToRem: m,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: i,
    fontWeightRegular: s,
    fontWeightMedium: a,
    fontWeightBold: c,
    ...y
  }, d, {
    clone: !1
    // No need to clone deep
  });
}
const Ii = 0.2, _i = 0.14, Mi = 0.12;
function I(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${Ii})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${_i})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${Mi})`].join(",");
}
const Wi = ["none", I(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), I(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), I(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), I(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), I(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), I(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), I(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), I(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), I(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), I(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), I(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), I(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), I(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), I(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), I(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), I(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), I(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), I(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), I(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), I(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), I(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), I(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), I(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), I(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], Di = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Li = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Wt(e) {
  return `${Math.round(e)}ms`;
}
function Fi(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function zi(e) {
  const t = {
    ...Di,
    ...e.easing
  }, n = {
    ...Li,
    ...e.duration
  };
  return {
    getAutoHeightDuration: Fi,
    create: (i = ["all"], s = {}) => {
      const {
        duration: a = n.standard,
        easing: c = t.easeInOut,
        delay: f = 0,
        ...l
      } = s;
      return (Array.isArray(i) ? i : [i]).map((p) => `${p} ${typeof a == "string" ? a : Wt(a)} ${c} ${typeof f == "string" ? f : Wt(f)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const Ki = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function Gi(e) {
  return ne(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function un(e = {}) {
  const t = {
    ...e
  };
  function n(r) {
    const i = Object.entries(r);
    for (let s = 0; s < i.length; s++) {
      const [a, c] = i[s];
      !Gi(c) || a.startsWith("unstable_") ? delete r[a] : ne(c) && (r[a] = {
        ...c
      }, n(r[a]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function ot(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: r = {},
    spacing: i,
    palette: s = {},
    transitions: a = {},
    typography: c = {},
    shape: f,
    ...l
  } = e;
  if (e.vars)
    throw new Error(ae(20));
  const p = St(s), d = on(e);
  let h = K(d, {
    mixins: Pi(d.breakpoints, r),
    palette: p,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: Wi.slice(),
    typography: ji(p, c),
    transitions: zi(a),
    zIndex: {
      ...Ki
    }
  });
  return h = K(h, l), h = t.reduce((m, g) => K(m, g), h), h.unstable_sxConfig = {
    ...Xe,
    ...l == null ? void 0 : l.unstable_sxConfig
  }, h.unstable_sx = function(g) {
    return Je({
      sx: g,
      theme: this
    });
  }, h.toRuntimeSource = un, h;
}
function Ui(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const Hi = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = Ui(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function ln(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function dn(e) {
  return e === "dark" ? Hi : [];
}
function Ni(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: r,
    ...i
  } = e, s = St(t);
  return {
    palette: s,
    opacity: {
      ...ln(s.mode),
      ...n
    },
    overlays: r || dn(s.mode),
    ...i
  };
}
function Vi(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const Qi = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], qi = (e) => (t, n) => {
  const r = e.rootSelector || ":root", i = e.colorSchemeSelector;
  let s = i;
  if (i === "class" && (s = ".%s"), i === "data" && (s = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (s = `[${i}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const a = {};
      return Qi(e.cssVarPrefix).forEach((c) => {
        a[c] = n[c], delete n[c];
      }), s === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: a
        }
      } : s ? {
        [s.replace("%s", t)]: a,
        [`${r}, ${s.replace("%s", t)}`]: n
      } : {
        [r]: {
          ...n,
          ...a
        }
      };
    }
    if (s && s !== "media")
      return `${r}, ${s.replace("%s", String(t))}`;
  } else if (t) {
    if (s === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [r]: n
        }
      };
    if (s)
      return s.replace("%s", String(t));
  }
  return r;
};
function Yi(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function u(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function Se(e) {
  return !e || !e.startsWith("hsl") ? e : an(e);
}
function Z(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = Ce(Se(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function Xi(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const q = (e) => {
  try {
    return e();
  } catch {
  }
}, Ji = (e = "mui") => bi(e);
function nt(e, t, n, r) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const i = r === "dark" ? "dark" : "light";
  if (!n) {
    e[r] = Ni({
      ...t,
      palette: {
        mode: i,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: s,
    ...a
  } = ot({
    ...n,
    palette: {
      mode: i,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[r] = {
    ...t,
    palette: s,
    opacity: {
      ...ln(i),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || dn(i)
  }, a;
}
function Zi(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: i = !1,
    cssVarPrefix: s = "mui",
    shouldSkipGeneratingVar: a = Vi,
    colorSchemeSelector: c = n.light && n.dark ? "media" : void 0,
    rootSelector: f = ":root",
    ...l
  } = e, p = Object.keys(n)[0], d = r || (n.light && p !== "light" ? "light" : p), h = Ji(s), {
    [d]: m,
    light: g,
    dark: y,
    ...A
  } = n, S = {
    ...A
  };
  let k = m;
  if ((d === "dark" && !("dark" in n) || d === "light" && !("light" in n)) && (k = !0), !k)
    throw new Error(ae(21, d));
  const w = nt(S, k, l, d);
  g && !S.light && nt(S, g, void 0, "light"), y && !S.dark && nt(S, y, void 0, "dark");
  let C = {
    defaultColorScheme: d,
    ...w,
    cssVarPrefix: s,
    colorSchemeSelector: c,
    rootSelector: f,
    getCssVar: h,
    colorSchemes: S,
    font: {
      ...Ei(w.typography),
      ...w.font
    },
    spacing: Xi(l.spacing)
  };
  Object.keys(C.colorSchemes).forEach((R) => {
    const o = C.colorSchemes[R].palette, b = (v) => {
      const j = v.split("-"), Q = j[1], Oe = j[2];
      return h(v, o[Q][Oe]);
    };
    if (o.mode === "light" && (u(o.common, "background", "#fff"), u(o.common, "onBackground", "#000")), o.mode === "dark" && (u(o.common, "background", "#000"), u(o.common, "onBackground", "#fff")), Yi(o, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), o.mode === "light") {
      u(o.Alert, "errorColor", O(o.error.light, 0.6)), u(o.Alert, "infoColor", O(o.info.light, 0.6)), u(o.Alert, "successColor", O(o.success.light, 0.6)), u(o.Alert, "warningColor", O(o.warning.light, 0.6)), u(o.Alert, "errorFilledBg", b("palette-error-main")), u(o.Alert, "infoFilledBg", b("palette-info-main")), u(o.Alert, "successFilledBg", b("palette-success-main")), u(o.Alert, "warningFilledBg", b("palette-warning-main")), u(o.Alert, "errorFilledColor", q(() => o.getContrastText(o.error.main))), u(o.Alert, "infoFilledColor", q(() => o.getContrastText(o.info.main))), u(o.Alert, "successFilledColor", q(() => o.getContrastText(o.success.main))), u(o.Alert, "warningFilledColor", q(() => o.getContrastText(o.warning.main))), u(o.Alert, "errorStandardBg", E(o.error.light, 0.9)), u(o.Alert, "infoStandardBg", E(o.info.light, 0.9)), u(o.Alert, "successStandardBg", E(o.success.light, 0.9)), u(o.Alert, "warningStandardBg", E(o.warning.light, 0.9)), u(o.Alert, "errorIconColor", b("palette-error-main")), u(o.Alert, "infoIconColor", b("palette-info-main")), u(o.Alert, "successIconColor", b("palette-success-main")), u(o.Alert, "warningIconColor", b("palette-warning-main")), u(o.AppBar, "defaultBg", b("palette-grey-100")), u(o.Avatar, "defaultBg", b("palette-grey-400")), u(o.Button, "inheritContainedBg", b("palette-grey-300")), u(o.Button, "inheritContainedHoverBg", b("palette-grey-A100")), u(o.Chip, "defaultBorder", b("palette-grey-400")), u(o.Chip, "defaultAvatarColor", b("palette-grey-700")), u(o.Chip, "defaultIconColor", b("palette-grey-700")), u(o.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), u(o.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), u(o.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), u(o.LinearProgress, "primaryBg", E(o.primary.main, 0.62)), u(o.LinearProgress, "secondaryBg", E(o.secondary.main, 0.62)), u(o.LinearProgress, "errorBg", E(o.error.main, 0.62)), u(o.LinearProgress, "infoBg", E(o.info.main, 0.62)), u(o.LinearProgress, "successBg", E(o.success.main, 0.62)), u(o.LinearProgress, "warningBg", E(o.warning.main, 0.62)), u(o.Skeleton, "bg", `rgba(${b("palette-text-primaryChannel")} / 0.11)`), u(o.Slider, "primaryTrack", E(o.primary.main, 0.62)), u(o.Slider, "secondaryTrack", E(o.secondary.main, 0.62)), u(o.Slider, "errorTrack", E(o.error.main, 0.62)), u(o.Slider, "infoTrack", E(o.info.main, 0.62)), u(o.Slider, "successTrack", E(o.success.main, 0.62)), u(o.Slider, "warningTrack", E(o.warning.main, 0.62));
      const v = Re(o.background.default, 0.8);
      u(o.SnackbarContent, "bg", v), u(o.SnackbarContent, "color", q(() => o.getContrastText(v))), u(o.SpeedDialAction, "fabHoverBg", Re(o.background.paper, 0.15)), u(o.StepConnector, "border", b("palette-grey-400")), u(o.StepContent, "border", b("palette-grey-400")), u(o.Switch, "defaultColor", b("palette-common-white")), u(o.Switch, "defaultDisabledColor", b("palette-grey-100")), u(o.Switch, "primaryDisabledColor", E(o.primary.main, 0.62)), u(o.Switch, "secondaryDisabledColor", E(o.secondary.main, 0.62)), u(o.Switch, "errorDisabledColor", E(o.error.main, 0.62)), u(o.Switch, "infoDisabledColor", E(o.info.main, 0.62)), u(o.Switch, "successDisabledColor", E(o.success.main, 0.62)), u(o.Switch, "warningDisabledColor", E(o.warning.main, 0.62)), u(o.TableCell, "border", E(Pe(o.divider, 1), 0.88)), u(o.Tooltip, "bg", Pe(o.grey[700], 0.92));
    }
    if (o.mode === "dark") {
      u(o.Alert, "errorColor", E(o.error.light, 0.6)), u(o.Alert, "infoColor", E(o.info.light, 0.6)), u(o.Alert, "successColor", E(o.success.light, 0.6)), u(o.Alert, "warningColor", E(o.warning.light, 0.6)), u(o.Alert, "errorFilledBg", b("palette-error-dark")), u(o.Alert, "infoFilledBg", b("palette-info-dark")), u(o.Alert, "successFilledBg", b("palette-success-dark")), u(o.Alert, "warningFilledBg", b("palette-warning-dark")), u(o.Alert, "errorFilledColor", q(() => o.getContrastText(o.error.dark))), u(o.Alert, "infoFilledColor", q(() => o.getContrastText(o.info.dark))), u(o.Alert, "successFilledColor", q(() => o.getContrastText(o.success.dark))), u(o.Alert, "warningFilledColor", q(() => o.getContrastText(o.warning.dark))), u(o.Alert, "errorStandardBg", O(o.error.light, 0.9)), u(o.Alert, "infoStandardBg", O(o.info.light, 0.9)), u(o.Alert, "successStandardBg", O(o.success.light, 0.9)), u(o.Alert, "warningStandardBg", O(o.warning.light, 0.9)), u(o.Alert, "errorIconColor", b("palette-error-main")), u(o.Alert, "infoIconColor", b("palette-info-main")), u(o.Alert, "successIconColor", b("palette-success-main")), u(o.Alert, "warningIconColor", b("palette-warning-main")), u(o.AppBar, "defaultBg", b("palette-grey-900")), u(o.AppBar, "darkBg", b("palette-background-paper")), u(o.AppBar, "darkColor", b("palette-text-primary")), u(o.Avatar, "defaultBg", b("palette-grey-600")), u(o.Button, "inheritContainedBg", b("palette-grey-800")), u(o.Button, "inheritContainedHoverBg", b("palette-grey-700")), u(o.Chip, "defaultBorder", b("palette-grey-700")), u(o.Chip, "defaultAvatarColor", b("palette-grey-300")), u(o.Chip, "defaultIconColor", b("palette-grey-300")), u(o.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), u(o.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), u(o.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), u(o.LinearProgress, "primaryBg", O(o.primary.main, 0.5)), u(o.LinearProgress, "secondaryBg", O(o.secondary.main, 0.5)), u(o.LinearProgress, "errorBg", O(o.error.main, 0.5)), u(o.LinearProgress, "infoBg", O(o.info.main, 0.5)), u(o.LinearProgress, "successBg", O(o.success.main, 0.5)), u(o.LinearProgress, "warningBg", O(o.warning.main, 0.5)), u(o.Skeleton, "bg", `rgba(${b("palette-text-primaryChannel")} / 0.13)`), u(o.Slider, "primaryTrack", O(o.primary.main, 0.5)), u(o.Slider, "secondaryTrack", O(o.secondary.main, 0.5)), u(o.Slider, "errorTrack", O(o.error.main, 0.5)), u(o.Slider, "infoTrack", O(o.info.main, 0.5)), u(o.Slider, "successTrack", O(o.success.main, 0.5)), u(o.Slider, "warningTrack", O(o.warning.main, 0.5));
      const v = Re(o.background.default, 0.98);
      u(o.SnackbarContent, "bg", v), u(o.SnackbarContent, "color", q(() => o.getContrastText(v))), u(o.SpeedDialAction, "fabHoverBg", Re(o.background.paper, 0.15)), u(o.StepConnector, "border", b("palette-grey-600")), u(o.StepContent, "border", b("palette-grey-600")), u(o.Switch, "defaultColor", b("palette-grey-300")), u(o.Switch, "defaultDisabledColor", b("palette-grey-600")), u(o.Switch, "primaryDisabledColor", O(o.primary.main, 0.55)), u(o.Switch, "secondaryDisabledColor", O(o.secondary.main, 0.55)), u(o.Switch, "errorDisabledColor", O(o.error.main, 0.55)), u(o.Switch, "infoDisabledColor", O(o.info.main, 0.55)), u(o.Switch, "successDisabledColor", O(o.success.main, 0.55)), u(o.Switch, "warningDisabledColor", O(o.warning.main, 0.55)), u(o.TableCell, "border", O(Pe(o.divider, 1), 0.68)), u(o.Tooltip, "bg", Pe(o.grey[700], 0.92));
    }
    Z(o.background, "default"), Z(o.background, "paper"), Z(o.common, "background"), Z(o.common, "onBackground"), Z(o, "divider"), Object.keys(o).forEach((v) => {
      const j = o[v];
      j && typeof j == "object" && (j.main && u(o[v], "mainChannel", Ce(Se(j.main))), j.light && u(o[v], "lightChannel", Ce(Se(j.light))), j.dark && u(o[v], "darkChannel", Ce(Se(j.dark))), j.contrastText && u(o[v], "contrastTextChannel", Ce(Se(j.contrastText))), v === "text" && (Z(o[v], "primary"), Z(o[v], "secondary")), v === "action" && (j.active && Z(o[v], "active"), j.selected && Z(o[v], "selected")));
    });
  }), C = t.reduce((R, o) => K(R, o), C);
  const x = {
    prefix: s,
    disableCssColorScheme: i,
    shouldSkipGeneratingVar: a,
    getSelector: qi(C)
  }, {
    vars: P,
    generateThemeVars: $,
    generateStyleSheets: z
  } = wi(C, x);
  return C.vars = P, Object.entries(C.colorSchemes[C.defaultColorScheme]).forEach(([R, o]) => {
    C[R] = o;
  }), C.generateThemeVars = $, C.generateStyleSheets = z, C.generateSpacing = function() {
    return sn(l.spacing, pt(this));
  }, C.getColorSchemeSelector = xi(c), C.spacing = C.generateSpacing(), C.shouldSkipGeneratingVar = a, C.unstable_sxConfig = {
    ...Xe,
    ...l == null ? void 0 : l.unstable_sxConfig
  }, C.unstable_sx = function(o) {
    return Je({
      sx: o,
      theme: this
    });
  }, C.toRuntimeSource = un, C;
}
function Dt(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: St({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function es(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: i = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: s = n == null ? void 0 : n.mode,
    ...a
  } = e, c = s || "light", f = i == null ? void 0 : i[c], l = {
    ...i,
    ...n ? {
      [c]: {
        ...typeof f != "boolean" && f,
        palette: n
      }
    } : void 0
  };
  if (r === !1) {
    if (!("colorSchemes" in e))
      return ot(e, ...t);
    let p = n;
    "palette" in e || l[c] && (l[c] !== !0 ? p = l[c].palette : c === "dark" && (p = {
      mode: "dark"
    }));
    const d = ot({
      ...e,
      palette: p
    }, ...t);
    return d.defaultColorScheme = c, d.colorSchemes = l, d.palette.mode === "light" && (d.colorSchemes.light = {
      ...l.light !== !0 && l.light,
      palette: d.palette
    }, Dt(d, "dark", l.dark)), d.palette.mode === "dark" && (d.colorSchemes.dark = {
      ...l.dark !== !0 && l.dark,
      palette: d.palette
    }, Dt(d, "light", l.light)), d;
  }
  return !n && !("light" in l) && c === "light" && (l.light = !0), Zi({
    ...a,
    colorSchemes: l,
    defaultColorScheme: c,
    ...typeof r != "boolean" && r
  }, ...t);
}
const ts = es();
function ns() {
  const e = li(ts);
  return e[$n] || e;
}
const hn = Object.fromEntries ? Object.fromEntries : (e) => {
  if (!e || !e[Symbol.iterator])
    throw new Error("Object.fromEntries() requires a single iterable argument");
  const t = {};
  return Object.keys(e).forEach((n) => {
    const [r, i] = e[n];
    t[r] = i;
  }), t;
};
function ie(e) {
  return Object.keys(e);
}
function oe(e, t) {
  if (!e)
    throw new Error(t);
}
function wt(e, t) {
  return t;
}
const xt = (e) => {
  const t = e.length;
  let n = 0, r = "";
  for (; n < t; n++) {
    const i = e[n];
    if (i == null)
      continue;
    let s;
    switch (typeof i) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(i))
          s = xt(i);
        else {
          oe(!wt(i, !1)), s = "";
          for (const a in i)
            i[a] && a && (s && (s += " "), s += a);
        }
        break;
      }
      default:
        s = i;
    }
    s && (r && (r += " "), r += s);
  }
  return r;
};
function rs(e, t) {
  var n;
  const r = wn();
  return (!r.current || t.length !== ((n = r.current.prevDeps) === null || n === void 0 ? void 0 : n.length) || r.current.prevDeps.map((i, s) => i === t[s]).indexOf(!1) >= 0) && (r.current = {
    v: e(),
    prevDeps: [...t]
  }), r.current.v;
}
function is(e) {
  return e instanceof Object && !("styles" in e) && !("length" in e) && !("__emotion_styles" in e);
}
const { createCssAndCx: ss } = /* @__PURE__ */ (() => {
  function e(n, r, i) {
    const s = [], a = nr(n, s, i);
    return s.length < 2 ? i : a + r(s);
  }
  function t(n) {
    const { cache: r } = n, i = (...a) => {
      const c = ur(a, r.registered);
      ir(r, c, !1);
      const f = `${r.key}-${c.name}`;
      e: {
        const l = a[0];
        if (!is(l))
          break e;
        Lt.saveClassNameCSSObjectMapping(r, f, l);
      }
      return f;
    };
    return { css: i, cx: (...a) => {
      const c = xt(a), f = Lt.fixClassName(r, c, i);
      return e(r.registered, i, f);
    } };
  }
  return { createCssAndCx: t };
})();
function gn(e) {
  const { useCache: t } = e;
  function n() {
    const r = t(), { css: i, cx: s } = rs(() => ss({ cache: r }), [r]);
    return { css: i, cx: s };
  }
  return { useCssAndCx: n };
}
const Lt = /* @__PURE__ */ (() => {
  const e = /* @__PURE__ */ new WeakMap();
  return {
    saveClassNameCSSObjectMapping: (t, n, r) => {
      let i = e.get(t);
      i === void 0 && (i = /* @__PURE__ */ new Map(), e.set(t, i)), i.set(n, r);
    },
    fixClassName: /* @__PURE__ */ (() => {
      function t(n) {
        let r = !1;
        return n.map(([i, s]) => {
          if (s === void 0)
            return i;
          let a;
          if (r)
            a = {
              "&&": s
            };
          else {
            a = i;
            for (const c in s)
              if (c.startsWith("@media")) {
                r = !0;
                break;
              }
          }
          return a;
        });
      }
      return (n, r, i) => {
        const s = e.get(n);
        return xt(t(r.split(" ").map((a) => [
          a,
          s == null ? void 0 : s.get(a)
        ])).map((a) => typeof a == "string" ? a : i(a)));
      };
    })()
  };
})();
function se(e) {
  if (!(e instanceof Object) || typeof e == "function")
    return e;
  const t = [];
  for (const n in e) {
    const r = e[n], i = typeof r;
    if (!(i === "string" || i === "number" && !isNaN(r) || i === "boolean" || r === void 0 || r === null))
      return e;
    t.push(`${n}:${i}_${r}`);
  }
  return "xSqLiJdLMd9s" + t.join("|");
}
function kt(e, t, n) {
  if (!(t instanceof Object))
    return e;
  const r = {};
  return ie(e).forEach((i) => r[i] = n(e[i], t[i])), ie(t).forEach((i) => {
    if (i in e)
      return;
    const s = t[i];
    typeof s == "string" && (r[i] = s);
  }), r;
}
const os = ({ classes: e, theme: t, muiStyleOverridesParams: n, css: r, cx: i, name: s }) => {
  var a, c;
  e: {
    if (s === "makeStyle no name") {
      s = void 0;
      break e;
    }
    if (n !== void 0 && s === void 0)
      throw new Error("To use muiStyleOverridesParams, you must specify a name using .withName('MyComponent')");
  }
  let f;
  try {
    f = s === void 0 ? void 0 : ((c = (a = t.components) === null || a === void 0 ? void 0 : a[
      s
      /*example*/
    ]) === null || c === void 0 ? void 0 : c.styleOverrides) || void 0;
  } catch {
  }
  const l = De(() => {
    if (f === void 0)
      return;
    const p = {};
    for (const d in f) {
      const h = f[d];
      h instanceof Object && (p[d] = r(typeof h == "function" ? h({
        theme: t,
        ownerState: n == null ? void 0 : n.ownerState,
        ...n == null ? void 0 : n.props
      }) : h));
    }
    return p;
  }, [
    f,
    se(n == null ? void 0 : n.props),
    se(n == null ? void 0 : n.ownerState),
    r
  ]);
  return e = De(() => kt(e, l, i), [e, l, i]), { classes: e };
};
let as = 0;
function pn(e) {
  const { useTheme: t, cache: n } = e, { useCache: r } = yn({ cacheProvidedAtInception: n }), { useCssAndCx: i } = gn({ useCache: r });
  function s(c) {
    const { name: f, uniqId: l = `${as++}` } = c ?? {}, p = typeof f != "object" ? f : Object.keys(f)[0];
    return function(d) {
      const h = typeof d == "function" ? d : () => d;
      return function(g, y) {
        const A = t();
        let { css: S, cx: k } = i();
        const w = r();
        let C = De(() => {
          const x = {}, P = typeof Proxy < "u" && new Proxy({}, {
            get: (R, o) => (typeof o == "symbol" && oe(!1), x[o] = `${w.key}-${l}${p !== void 0 ? `-${p}` : ""}-${o}-ref`)
          }), $ = h(A, g, P || {}), z = hn(ie($).map((R) => {
            const o = $[R];
            return o.label || (o.label = `${p !== void 0 ? `${p}-` : ""}${R}`), [
              R,
              `${S(o)}${wt(R, R in x) ? ` ${x[R]}` : ""}`
            ];
          }));
          return ie(x).forEach((R) => {
            R in z || (z[R] = x[R]);
          }), z;
        }, [w, S, k, A, se(g)]);
        {
          const x = y == null ? void 0 : y.props.classes;
          C = De(() => kt(C, x, k), [C, se(x), k]);
        }
        {
          const x = os({
            classes: C,
            css: S,
            cx: k,
            name: p ?? "makeStyle no name",
            idOfUseStyles: l,
            muiStyleOverridesParams: y,
            // NOTE: If it's not a Mui Theme the plugin is resilient, it will not crash
            theme: A
          });
          x.classes !== void 0 && (C = x.classes), x.css !== void 0 && (S = x.css), x.cx !== void 0 && (k = x.cx);
        }
        return {
          classes: C,
          theme: A,
          css: S,
          cx: k
        };
      };
    };
  }
  function a() {
    const c = t(), { css: f, cx: l } = i();
    return { theme: c, css: f, cx: l };
  }
  return { makeStyles: s, useStyles: a };
}
const mn = at(void 0);
function Ss(e) {
  const { children: t, value: n } = e;
  return Gt.createElement(mn.Provider, { value: n }, t);
}
const { createUseCache: yn } = /* @__PURE__ */ (() => {
  function e() {
    return ct(mn);
  }
  function t(n) {
    const { cacheProvidedAtInception: r } = n;
    function i() {
      var s;
      const a = lr(), c = e(), f = (s = r ?? c) !== null && s !== void 0 ? s : a;
      if (f === null)
        throw new Error([
          "In order to get SSR working with tss-react you need to explicitly provide an Emotion cache.",
          "MUI users be aware: This is not an error strictly related to tss-react, with or without tss-react,",
          "MUI needs an Emotion cache to be provided for SSR to work.",
          "Here is the MUI documentation related to SSR setup: https://mui.com/material-ui/guides/server-rendering/",
          "TSS provides helper that makes the process of setting up SSR easier: https://docs.tss-react.dev/ssr"
        ].join(`
`));
      return f;
    }
    return { useCache: i };
  }
  return { createUseCache: t };
})();
function Ft(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function cs(e) {
  const { useTheme: t, cache: n } = e, { makeStyles: r } = pn({ useTheme: t, cache: n });
  function i(s, a, c) {
    const f = typeof s == "string" ? (() => {
      const m = s, g = function({ children: y, ...A }) {
        return xn(m, A, y);
      };
      return Object.defineProperty(g, "name", {
        value: Ft(m)
      }), g;
    })() : s, l = (() => {
      {
        const { name: g } = c ?? {};
        if (g !== void 0)
          return typeof g != "object" ? g : Object.keys(g)[0];
      }
      let m;
      e: {
        const g = f.displayName;
        if (typeof g != "string" || g === "")
          break e;
        m = g;
      }
      e: {
        if (m !== void 0)
          break e;
        const g = f.name;
        if (typeof g != "string" || g === "")
          break e;
        m = g;
      }
      if (m !== void 0)
        return m = m.replace(/\$/g, "usd"), m = m.replace(/\(/g, "_").replace(/\)/g, "_"), m = m.replace(/[^a-zA-Z0-9-_]/g, "_"), m;
    })(), p = r({ ...c, name: l })(typeof a == "function" ? (m, g, y) => Kt(a(m, g, y)) : Kt(a));
    function d(m) {
      for (const g in m)
        if (g !== "root")
          return !0;
      return !1;
    }
    const h = Ut(function(m, g) {
      const { className: y, classes: A, ...S } = m, { classes: k, cx: w } = p(m, { props: m }), C = w(k.root, y);
      return bn.set(k, {
        ...k,
        root: C
      }), Gt.createElement(f, { ref: g, className: d(k) ? y : C, ...typeof s == "string" ? {} : { classes: k }, ...S });
    });
    return l !== void 0 && (h.displayName = `${Ft(l)}WithStyles`, Object.defineProperty(h, "name", { value: h.displayName })), h;
  }
  return i.getClasses = fs, { withStyles: i };
}
const bn = /* @__PURE__ */ new WeakMap(), zt = "getClasses should only be used in conjunction with withStyles";
function fs(e) {
  const t = e.classes;
  if (t === void 0)
    throw new Error(zt);
  const n = bn.get(t);
  if (n === void 0)
    throw new Error(zt);
  return n;
}
function Kt(e) {
  const t = {}, n = {};
  return Object.keys(e).forEach((r) => (r.startsWith("@media") ? n : t)[r] = e[r]), Object.keys(n).forEach((r) => {
    const i = n[r];
    Object.keys(i).forEach((s) => {
      var a;
      return t[s] = {
        ...(a = t[s]) !== null && a !== void 0 ? a : {},
        [r]: i[s]
      };
    });
  }), t;
}
const us = !(typeof document == "object" && typeof (document == null ? void 0 : document.getElementById) == "function") && !(typeof jest < "u") && !(typeof mocha < "u") && !(typeof __vitest_worker__ < "u");
function ls(e) {
  Cn = 0, te.splice(0, te.length);
  const { useContext: t, usePlugin: n, cache: r } = e, { useCache: i } = yn({ cacheProvidedAtInception: r }), { useCssAndCx: s } = gn({ useCache: i });
  return { tss: We({
    useContext: t,
    useCache: i,
    useCssAndCx: s,
    usePlugin: n ?? (({ classes: f, cx: l, css: p }) => ({ classes: f, cx: l, css: p })),
    name: void 0,
    doesUseNestedSelectors: !1
  }) };
}
let Cn = 0;
const te = [];
function We(e) {
  const { useContext: t, useCache: n, useCssAndCx: r, usePlugin: i, name: s, doesUseNestedSelectors: a } = e;
  return {
    withParams: () => We({ ...e }),
    withName: (c) => We({
      ...e,
      name: typeof c != "object" ? c : Object.keys(c)[0]
    }),
    withNestedSelectors: () => We({
      ...e,
      doesUseNestedSelectors: !0
    }),
    create: (c) => {
      const f = `x${Cn++}`;
      if (s !== void 0)
        for (; ; ) {
          const p = te.find((d) => d.name === s);
          if (p === void 0)
            break;
          te.splice(te.indexOf(p), 1);
        }
      const l = typeof c == "function" ? c : () => c;
      return function(d) {
        var h, m, g;
        const { classesOverrides: y, ...A } = d ?? {}, S = t(), { css: k, cx: w } = r(), C = n(), x = () => {
          const z = {}, R = l({
            ...d,
            ...S,
            ...a ? {
              classes: typeof Proxy > "u" ? {} : new Proxy({}, {
                get: (b, v) => {
                  if (typeof v == "symbol" && oe(!1), us && s === void 0)
                    throw new Error([
                      "tss-react: In SSR setups, in order to use nested selectors, you must also give a unique name to the useStyle function.",
                      'Solution: Use tss.withName("ComponentName").withNestedSelectors<...>()... to set a name.'
                    ].join(`
`));
                  e: {
                    if (s === void 0)
                      break e;
                    let j = te.find((Q) => Q.name === s && Q.idOfUseStyles === f);
                    j === void 0 && (j = { name: s, idOfUseStyles: f, nestedSelectorRuleNames: /* @__PURE__ */ new Set() }, te.push(j)), j.nestedSelectorRuleNames.add(v);
                  }
                  e: {
                    if (s === void 0 || !(te.find((Q) => Q.name === s && Q.idOfUseStyles !== f && Q.nestedSelectorRuleNames.has(v)) !== void 0))
                      break e;
                    throw new Error([
                      `tss-react: There are in your codebase two different useStyles named "${s}" that`,
                      `both use use the nested selector ${v}.
`,
                      `This may lead to CSS class name collisions, causing nested selectors to target elements outside of the intended scope.
`,
                      `Solution: Ensure each useStyles using nested selectors has a unique name.
`,
                      'Use: tss.withName("UniqueName").withNestedSelectors<...>()...'
                    ].join(" "));
                  }
                  return z[v] = `${C.key}-${s !== void 0 ? s : f}-${v}-ref`;
                }
              })
            } : {}
          });
          let o = hn(ie(R).map((b) => {
            const v = R[b];
            return v.label || (v.label = `${s !== void 0 ? `${s}-` : ""}${b}`), [
              b,
              `${k(v)}${wt(b, b in z) ? ` ${z[b]}` : ""}`
            ];
          }));
          return ie(z).forEach((b) => {
            b in o || (o[b] = z[b]);
          }), o = kt(o, y, w), o;
        }, P = ds({
          cache: C,
          cssObjectByRuleNameOrGetCssObjectByRuleName: c,
          classesOverridesRef: se(y),
          paramsAndPluginParamsRef: se(A),
          idOfUseStyles: f,
          context: S,
          getClasses: x
        }), $ = i({
          classes: P,
          css: k,
          cx: w,
          idOfUseStyles: f,
          name: s,
          ...S,
          ...A
        });
        return {
          classes: (h = $.classes) !== null && h !== void 0 ? h : P,
          css: (m = $.css) !== null && m !== void 0 ? m : k,
          cx: (g = $.cx) !== null && g !== void 0 ? g : w,
          ...S
        };
      };
    }
  };
}
const je = /* @__PURE__ */ new WeakMap();
function ds(e) {
  const { cache: t, cssObjectByRuleNameOrGetCssObjectByRuleName: n, classesOverridesRef: r, paramsAndPluginParamsRef: i, idOfUseStyles: s, context: a, getClasses: c } = e;
  e: {
    const l = je.get(t);
    if (l === void 0)
      break e;
    const p = l.get(n);
    if (p === void 0)
      break e;
    const d = p.get(r);
    if (d === void 0)
      break e;
    const h = d.get(i);
    if (h === void 0)
      break e;
    const m = h.find(({ context: g }) => {
      if (g === a)
        return !0;
      if (ie(g).length !== ie(a).length)
        return !1;
      for (const y in g)
        if (se(g[y]) !== se(a[y]))
          return !1;
      return !0;
    });
    if (m === void 0)
      break e;
    if ((m == null ? void 0 : m.idOfUseStyles) !== s) {
      h.splice(h.indexOf(m), 1);
      break e;
    }
    return m.result;
  }
  const f = c();
  {
    je.has(t) || je.set(t, /* @__PURE__ */ new WeakMap());
    const l = je.get(t);
    oe(l !== void 0), l.has(n) || l.set(n, /* @__PURE__ */ new Map());
    const p = l.get(n);
    oe(p !== void 0), p.has(r) || (p.size > 200 && p.clear(), p.set(r, /* @__PURE__ */ new Map()));
    const d = p.get(r);
    if (oe(d !== void 0), !d.has(i)) {
      e: {
        const m = typeof i == "string" ? 257 : 5;
        if (d.size < m)
          break e;
        d.clear();
      }
      d.set(i, []);
    }
    let h = d.get(i);
    oe(h !== void 0), h.length > 5 && (h = []), h.push({ idOfUseStyles: s, context: a, result: f });
  }
  return f;
}
function hs(e) {
  return {
    ...pn(e),
    ...cs(e)
  };
}
const { tss: gs } = ls({
  useContext: () => ({})
});
gs.create({});
const { makeStyles: ws, withStyles: xs } = hs({
  useTheme: ns
});
export {
  H as $,
  xs as A,
  An as B,
  nr as C,
  He as D,
  Li as E,
  fi as F,
  sn as G,
  gr as H,
  Hn as I,
  Un as J,
  Nn as K,
  he as L,
  Kn as M,
  Yt as N,
  qt as O,
  _n as P,
  In as Q,
  ft as R,
  Bn as S,
  $n as T,
  be as U,
  B as V,
  T as W,
  Le as X,
  F as Y,
  Nt as Z,
  ut as _,
  li as a,
  $e as a0,
  ze as a1,
  J as a2,
  _e as a3,
  jn as a4,
  L as a5,
  Y as a6,
  rt as a7,
  ve as a8,
  G as a9,
  ms as aa,
  ji as ab,
  er as ac,
  Ss as ad,
  mi as b,
  nn as c,
  Xe as d,
  es as e,
  on as f,
  Ui as g,
  ee as h,
  ne as i,
  pt as j,
  K as k,
  bs as l,
  ws as m,
  Be as n,
  ae as o,
  ts as p,
  di as q,
  Cs as r,
  Je as s,
  Ct as t,
  ns as u,
  bt as v,
  ur as w,
  ys as x,
  dr as y,
  ir as z
};
//# sourceMappingURL=tss-DN0acMKN.mjs.map
